export class CondicionIVA{
    id: string;
    descripcion: string;
    abreviatura: string;
    liquida: boolean;
    liquidaIIBB?: boolean;
    discrimina: boolean;
    percibeIVA: boolean;
    activa: boolean;
    codigoAFIP: string;
    tipoCliente: number;
  static ConsumidorFinal: number;
}